module.exports = __webpack_public_path__ + "img/icon-ai.8dd8916b.svg";